if($('.id--16').length){
    var totalWeight = 0;
    var containsAtypShipping = false;
    $('.cart-items .cart-item').each(function() {
        var sku = $(this).data('micro-sku').toString(); 
        var price = parseFloat($(this).find('.cart-item-price').text().replace(/ /g, ''))
        var amount = parseFloat($(this).find('.cart-item-amount').text().replace(/ /g, ''))
        if (productInfoByCode.hasOwnProperty(sku)) {
            var weightPerItem = productInfoByCode[sku].weight;
            var weightForThisItem = weightPerItem * amount;
            totalWeight += weightForThisItem;
            $(this).find('.cart-item-name').append('<span class="blockBox" style="display:block;color:#666;">(1 paleta má '+ weightPerItem + ' kg)');
        }
        if (atypShipping.includes(sku)) {
            containsAtypShipping = true;
        }

    });
    var price = parseFloat($('.price-wrapper .price.price-primary span').text().replace(/ /g, '').replace('€', ''))
   // $('.price-wrapper').append('<span class="price-label price-secondary">Cena za kilogram</span><strong class="price price-secondary"><span class="kgPrize">'+Number(price/totalWeight).ShoptetFormatAsCurrency()+' /kg</span></strong>')

    var colorboxContent = '<div class="customDeliveryContent">'
        colorboxContent += '<p>Pro zjištění možností doručení vyplňte PSČ. Následně vám sdělíme možnosti.</p>'
        colorboxContent += '<form id="validateZip"><fieldset>'
        colorboxContent += '<div class="rowLine"><label for="zip">PSČ</label>'
        colorboxContent += '<input type="text" id="zip" placeholder="např. 701 00" title="Vložte vaše PSČ"></div>'
        colorboxContent += '<div class="rowLine"><input type="submit" value="Ověřit" class="btn btn-secondary"></div>'
        colorboxContent += '</fieldset></form>'
    colorboxContent += '</div>'
    if (!containsAtypShipping) {
        $('#order-shipping-methods').before(colorboxContent)
    }
        $('form#validateZip').on('submit', function(e){
            e.preventDefault();
            $('.deliveryRow').remove()
            var userZip = $('#zip').val().replace(/\s/g, '');
            var userZip = $('#zip').val().replace(/\s/g, '');
            if (userZip.length === 5 && /^\d+$/.test(userZip)) {
                var csvData = JSON.parse(sessionStorage.getItem('csvDataDelivery'));
                if (csvData) {
                    var found = csvData.find(function(row) {
                        return row.PSC === userZip; // Porovnání PSČ
                    });
                    if (found) {
                        sessionStorage.setItem('zipValue', userZip);
                        $('body').addClass('haveShipping')
                        $('.notMinimalOrder').remove()
                        $('#order-shipping-methods').show()
                        $('#order-shipping-methods>div').removeClass('active')
                        $('#order-shipping-methods>div:not("#shipping-'+found['ID-DOPRAVY']+'"), #order-shipping-methods>div:not("#shipping-67")').hide()
                        if (PSCHideExterniDoprava.includes(zipPrefix)) {
                            if ($('div#order-shipping-methods div.radio-wrapper#shipping-'+zipPrefix).length > 0) {
                                $('#shipping-74').hide();
                            }
                        }
                        //$('#order-shipping-methods>div:not("#shipping-'+found['ID-DOPRAVY']+'")').hide()
                        if($('#order-shipping-methods>div#shipping-'+found['ID-DOPRAVY']).length){
                            if (found['POVOLIT-ATYPICKOU'] === '1') {
                                console.log(found['ID-DOPRAVY'])
                                // Speciální logika pro zahrnutí #shipping-67
                                $('#order-shipping-methods>div#shipping-67').show();
                                $('#order-shipping-methods>div#shipping-'+found['ID-DOPRAVY']).show();
                                shoptet.checkoutShared.callShippingBillingRelations();
                                shoptet.checkoutShared.replacingChosenShippingAndBilling();
                                setTimeout(function(){
                                    var price = parseFloat($('.price-wrapper .price.price-primary span').text().replace(/ /g, '').replace('€', ''))
                                    console.log(price)
                                    console.log(totalWeight)
                                    $('.price-wrapper .kgPrize').html(Number(price/totalWeight).ShoptetFormatAsCurrency()+' /kg')
                                }, 250)
                            }
                            else{
                                console.log(found['ID-DOPRAVY'])
                                $('#order-shipping-methods>div#shipping-'+found['ID-DOPRAVY']).addClass('active').show()
                                $('#order-shipping-methods>div#shipping-'+found['ID-DOPRAVY']+' input').trigger('click');
                                shoptet.checkoutShared.callShippingBillingRelations();
                                shoptet.checkoutShared.replacingChosenShippingAndBilling();
                                setTimeout(function(){
                                    var price = parseFloat($('.price-wrapper .price.price-primary span').text().replace(/ /g, '').replace('€', ''))
                                    console.log(price)
                                    console.log(totalWeight)
                                    $('.price-wrapper .kgPrize').html(Number(price/totalWeight).ShoptetFormatAsCurrency()+' /kg')
                                }, 250)
                               

                            }
                        }
                        else{
                            var cartItems = getShoptetDataLayer('cart') || [];
                            var hasYesShippingItem = cartItems.some(function(item) {
                                var info = productInfoByCode[item.code];
                                return info && info.shipping === "yes";
                            });

                            var hasNoShippingItem = cartItems.some(function(item) {
                                var info = productInfoByCode[item.code];
                                return info && info.shipping === "no";
                            });

                            if (hasYesShippingItem && hasNoShippingItem) {
                                $('#order-shipping-methods').after('<p class="notMinimalOrder">'+found['TEXT-KOSIK']+'</p><p class="text-center backLink"><a href="/kosik/">Vrátit se o krok zpět</a></p>')
                                $('#order-shipping-methods>div.active').removeClass('active')
                                $('#order-shipping-methods>div.active input').off('click')
                                $('#order-shipping-methods>div#shipping-71').addClass('active').show()
                                $('#order-shipping-methods>div#shipping-71 input').trigger('click');
                                shoptet.checkoutShared.callShippingBillingRelations();
                                shoptet.checkoutShared.replacingChosenShippingAndBilling();
                                    setTimeout(function(){
                                        var price = parseFloat($('.price-wrapper .price.price-primary span').text().replace(/ /g, '').replace('€', ''))
                                        console.log(price)
                                        console.log(totalWeight)
                                        $('.price-wrapper .kgPrize').html(Number(price/totalWeight).ShoptetFormatAsCurrency()+' /kg')
                                }, 250)
                            }
                            else if(hasYesShippingItem){
                                $('#order-shipping-methods>div.active').removeClass('active')
                                $('#order-shipping-methods>div.active input').off('click')
                                $('#order-shipping-methods>div#shipping-74').addClass('active').show()
                                $('#order-shipping-methods>div#shipping-74 input').trigger('click');
                                shoptet.checkoutShared.callShippingBillingRelations();
                                shoptet.checkoutShared.replacingChosenShippingAndBilling();
                            }
                            else{
                                $('#order-shipping-methods').after('<p class="notMinimalOrder">'+found['TEXT-KOSIK']+'</p><p class="text-center backLink"><a href="/kosik/">Vrátit se o krok zpět</a></p>')
                                $('#order-shipping-methods>div.active').removeClass('active')
                                $('#order-shipping-methods>div.active input').off('click')
                                $('#order-shipping-methods>div#shipping-71').addClass('active').show()
                                $('#order-shipping-methods>div#shipping-71 input').trigger('click');
                                shoptet.checkoutShared.callShippingBillingRelations();
                                shoptet.checkoutShared.replacingChosenShippingAndBilling();
                                    setTimeout(function(){
                                        var price = parseFloat($('.price-wrapper .price.price-primary span').text().replace(/ /g, '').replace('€', ''))
                                        console.log(price)
                                        console.log(totalWeight)
                                        $('.price-wrapper .kgPrize').html(Number(price/totalWeight).ShoptetFormatAsCurrency()+' /kg')
                                }, 250)
                            }                            
                        }
                       // var billingIds = $('#order-shipping-methods .radio-wrapper.active').find('input:checked').attr('data-relations');
                        //shoptet.checkoutShared.changePaymentRelations(billingIds);
                       
                    } else {
                        var cartItems = getShoptetDataLayer('cart') || [];
                        var hasYesShippingItem = cartItems.some(function(item) {
                            var info = productInfoByCode[item.code];
                            return info && info.shipping === "yes";
                        });

                        var hasNoShippingItem = cartItems.some(function(item) {
                            var info = productInfoByCode[item.code];
                            return info && info.shipping === "no";
                        });

                        if (hasYesShippingItem && hasNoShippingItem) {
                            $(this).after('<div class="deliveryRow red">'+hlaskaNedorucujeme+'</div>');
                            $('#order-shipping-methods>div.active').removeClass('active')
                            $('#order-shipping-methods>div.active input').off('click')
                            $('#order-shipping-methods>div#shipping-71').addClass('active').show()
                            $('#order-shipping-methods>div#shipping-71 input').trigger('click');
                            shoptet.checkoutShared.callShippingBillingRelations();
                            shoptet.checkoutShared.replacingChosenShippingAndBilling();
                        }
                        else if(hasYesShippingItem){
                            $(this).after('<div class="deliveryRow green">'+hlaskaDopravaZdarma+'</div>');
                            $('#order-shipping-methods>div.active').removeClass('active')
                            $('#order-shipping-methods>div.active input').off('click')
                            $('#order-shipping-methods>div#shipping-74').addClass('active').show()
                            $('#order-shipping-methods>div#shipping-74 input').trigger('click');
                            shoptet.checkoutShared.callShippingBillingRelations();
                            shoptet.checkoutShared.replacingChosenShippingAndBilling();
                        }
                        else{
                            sessionStorage.removeItem('zipValue');
                            $('body').removeClass('haveShipping')
                            $('#order-shipping-methods>div:not(.active)').hide()
                            $('.notMinimalOrder').remove()
                            var zipPrefix = userZip.substring(0, 2);
                            if (ZIP.includes(zipPrefix)) {
                                // První dvě číslice PSČ jsou v poli ZIP
                                $(this).after('<div class="deliveryRow green">Do vaší oblasti doručujeme. Pro více informací nás neváhejte <a href="/kontakt/" target="_blank">kontaktovat</a>.</div>')
                            } else {
                                // PSČ není v našem rozsahu doručování
                                $(this).after('<div class="deliveryRow red">'+hlaskaNedorucujeme+'</div>');
                                $('#order-shipping-methods>div.active').removeClass('active')
                                $('#order-shipping-methods>div.active input').off('click')
                                $('#order-shipping-methods>div#shipping-71').addClass('active').show()
                                $('#order-shipping-methods>div#shipping-71 input').trigger('click');
                                shoptet.checkoutShared.callShippingBillingRelations();
                                shoptet.checkoutShared.replacingChosenShippingAndBilling();
                            }
                        }


                        
                    }
                } else {
                    // Nejsou načtená žádná data
                }
            } else {
                // Neplatné PSČ
                $('body').removeClass('haveShipping')
                $('#order-shipping-methods>div:not(.active)').hide()
                $('.notMinimalOrder').remove()
                $(this).after('<div class="deliveryRow alert">Zadejte PSČ ve správném formátu, například 755 01.</div>')

            }
        });
        
   
}

if($('.id--9').length){
    $(document).ready(function(){
        mhHmotnost()
    });
    document.addEventListener('ShoptetDOMCartContentLoaded', function () {
        mhHmotnost();
    });
}

if($('.id--17').length){
    var storedZipValue = sessionStorage.getItem('zipValue');
    if(storedZipValue){
        $('#billZip').addClass('disebleInput').val(storedZipValue)
    }

    var totalWeight = 0;
    $('.cart-items .cart-item').each(function() {
        var sku = $(this).data('micro-sku').toString(); 
        var price = parseFloat($(this).find('.cart-item-price').text().replace(/ /g, ''))
        var amount = parseFloat($(this).find('.cart-item-amount').text().replace(/ /g, ''))
        if (productInfoByCode.hasOwnProperty(sku)) {
            var weightPerItem = productInfoByCode[sku].weight;
            var weightForThisItem = weightPerItem * amount;
            totalWeight += weightForThisItem;
            $(this).find('.cart-item-name').append('<span class="blockBox" style="display:block;color:#666;">(1 paleta má '+ weightPerItem + ' kg)');

        }
    });
    var price = parseFloat($('.price-wrapper .price.price-primary span').text().replace(/ /g, '').replace('€', ''))
    //$('.price-wrapper').append('<span class="price-label price-secondary">Cena za kilogram</span><strong class="price price-secondary"><span>'+Number(price/totalWeight).ShoptetFormatAsCurrency()+' /kg</span></strong>')
   
}

function mhHmotnost(){
    $('.cart-table tr.removeable').each(function() {
        var sku = $(this).data('micro-sku').toString(); 
        if (productInfoByCode.hasOwnProperty(sku)) {
            $(this).find('.unit-value').append(' <br>(' + productInfoByCode[sku].weight + ' kg)');
        }
    });
}

if($('.id--15').length){
    $(document).ready(function(){
        var productInfoByName = {};
        for (var sku in productInfoByCode) {
            if (productInfoByCode.hasOwnProperty(sku)) {
                var productInfo = productInfoByCode[sku];
                productInfoByName[productInfo.name] = { weight: productInfo.weight, sku: sku };
            }
        }

        $('.co-order table tr').each(function() {
            var name = $(this).find('.p-name span[data-testid="recapItemName"]').text().trim(); 
            if (productInfoByName.hasOwnProperty(name)) {
                var productInfo = productInfoByName[name];
                var weight = productInfo.weight;
                var name = productInfo.name;
                $(this).find('.p-quantity').append('<span class="blockBox" style="display:block;color:#666;">(1 paleta má '+ weight + ' kg)');
            }
        });
    })
    
}